import { toastQueue } from '@/notifications';

export function Toasts() {
  const items = toastQueue.value;
  return (
    <div
      class="fixed top-0 right-0 z-50 pt-[calc(env(safe-area-inset-top)+0.5rem)] pr-3 flex flex-col gap-2 pointer-events-none"
      role="region"
      aria-live="polite"
      aria-label="Értesítések"
    >
      {items.map((t) => (
        <div
          key={t.id}
          class={`pointer-events-auto rounded-lg px-3 py-2 text-sm shadow-lg max-w-xs ${t.kind === 'error' ? 'bg-red-600 text-white' : 'bg-gray-900 text-white'}`}
        >{t.text}</div>
      ))}
    </div>
  );
}
